module.exports = __webpack_public_path__ + "img/tickets-empty-state.f336bc33.png";